<script setup lang="ts">
/**
 * 渲染 Markdown 正文。
 *
 * **全应用唯一使用 `v-html` 的地方。** 注入的 HTML 是 `renderMarkdown()` 的产物：
 * markdown-it 关掉了 `html`（原始标签一律转义），随后 `sanitizeRenderedHtml()`
 * 再去掉 script 类标签、内联事件处理器和 `javascript:` 协议。
 * 除了这个组件，任何地方都不允许把裸字符串交给 `v-html`——
 * 这条界线一旦被跨过，流式渲染的便利就变成了 XSS 的入口。
 *
 * 流式容错：`renderMarkdown(source, {streaming:true})` 会先把未闭合的围栏补上。
 * 不补的话，每来一个 delta，整段代码块就在"代码块内 / 代码块外"之间来回切换，
 * 视觉上是一次次的整块闪烁。
 */

import { computed } from 'vue';

import { cn } from '../../lib/cn';
import { renderMarkdown } from '../../lib/markdown';

const props = withDefaults(
  defineProps<{ content: string; streaming?: boolean; className?: string }>(),
  { streaming: false },
);

const html = computed(() => renderMarkdown(props.content, { streaming: props.streaming }).html);
</script>

<template>
  <div :class="cn('md-body', props.className)">
    <div v-html="html" />
    <span v-if="props.streaming && props.content.length > 0" class="md-caret" aria-hidden="true" />
  </div>
</template>
